import React, { useRef, useEffect, useState } from 'react';
import './navbar-routes.css';

export default function NavbarRoutes({ openCustomizationModal }) {
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    // Function to update the time
    const updateClock = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const formattedTime = `${hours % 12 || 12}:${minutes < 10 ? '0' + minutes : minutes} ${hours >= 12 ? 'pm' : 'am'}`;
      setCurrentTime(formattedTime);
    };

    // Update the clock immediately on mount
    updateClock();

    // Set up an interval to update the clock every second
    const intervalId = setInterval(updateClock, 5000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className='navbar-routes-container'>
      <div className='navbar-routes-title-time-container'>
        {currentTime}
      </div>
      <div className='navbar-routes-title-container'>
        Choocago!
      </div>
      <div className='navbar-routes-open-customization-container' onClick={openCustomizationModal}>
        Customize
      </div>
    </div>
  );
}
